// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox_checkbox__3dXsV","label":"checkbox_label__3mkbq"};